module.exports = __webpack_public_path__ + "activity_icon-659107ecf7659fa27b9cc47fc03a6d0e.png";